import React from "react";

import { FileRecordListingProvider } from "./context/FileRecordListingProvider";
import { FileRecordListing } from "./FileRecordListing";

export const FileRecordListingDashboard: React.VFC = () => {
    return (
        <FileRecordListingProvider>
            <FileRecordListing />
        </FileRecordListingProvider>
    );
};
